import apiClient from "@/libs/axios";
// import store from "@/state/store";
import router from "@/router";

export const state = {
    data: [],
    details: null,
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setDetails: (state, data) => {
        state.details = data.result
    },

    updateDetails: (state, data) => {
        state.details = data.result
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, vendor: {...item.vendor, is_active: data.vendor.is_active}} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async appointments({ commit }, data) {
        await apiClient
            .get(`api/v1/appointments?filter[vendor_id]=${data.id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },
    async vendorAppointments({ commit }) {
        await apiClient
            .get(`api/v1/appointments/vendor-appointments`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },

    async details({ commit }, id) {
        console.log(id)
        await apiClient
            .get(`api/v1/appointments/show?id=${id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setDetails', response.data);
                }
            })
            .catch(error => {
                throw error;
            })
    },

    async approve({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .patch(`api/v1/appointments/change-status`, {id: data.id, status: data.status})
            .then(response => {
                console.log(response.data.result)
                if (response.status === 200) {
                    if (router.currentRoute._value.name === 'vendor-appointments-details') {
                        commit('updateDetails', response.data);
                    } else {
                        commit('updateData', response.data)
                    }
                }
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                throw error;
            },);
        commit('app/loadingFinish', null, {root: true});
    },

    async markAsCompleted({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .patch(`api/v1/appointments/change-status`, {id: data.id, status: 'completed'})
            .then(response => {
                console.log(response.data.result)
                if (response.status === 200) {
                    if (router.currentRoute._value.name === 'vendor-appointments-details') {
                        commit('updateDetails', response.data);
                    } else {
                        commit('updateData', response.data)
                    }
                }
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async reject({ commit }, data) {
        await apiClient
            .patch(`api/v1/appointments/reject`, {id: data.id, reject_reason: data.reject_reason})
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    if (router.currentRoute._value.name === 'vendor-appointments-details') {
                        commit('updateDetails', response.data);
                    } else {
                        commit('updateData', response.data);
                    }
                }
            })
            .catch(error => {
                throw error;
            },);
    }
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getDetails(state) {
        return state.details;
    },
    getTotal(state) {
        return state.total;
    },
};
